import React, { useEffect, useState } from "react";
import "../assets/css/footer.css";
import { IoCall } from "react-icons/io5";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Footer = () => {

    const [products, setProducts] = useState([])
    const backendUrl = process.env.REACT_APP_BACKEND_URI
    const navigate = useNavigate()

    useEffect(() => {
        axios.get(`${backendUrl}/products`)
            .then(res => { setProducts(res.data); console.log(products) })
            .catch(err => console.error(err))
    }, [backendUrl])

    return (
        <>
            <footer className="footer">
                {/* MAIN FOOTER */}
                <div className="footer-main">
                    <div className="footer-grid">

                        {/* PRODUCTS */}
                        <div className="footer-col">
                            <h4>Products</h4>
                            <ul>
                                {products
                                    .filter(product => !product.is_latest_product)
                                    .map(product => (
                                        <li
                                            key={product._id}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => navigate(`/product/${product._id}`)}
                                        >
                                            {product.title}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>

                        {/* CONTACT */}
                        <div className="footer-col">
                            <h4>Contact</h4>

                            <p>
                                Manufecturing Address:
                                PLOT NO 1644, ROAD NO-16 G.I.D.C. <br />
                                SARIGAM STATION BHILAD. <br />
                                DIST.VASAD - 396155
                            </p>
                            <p>
                                Office Address: <br />
                                First Floor, 53, Shivanjali Row House, <br />
                                Pramukhswami Over Bridge, Sumul Dairy Agency, <br />
                                Varachha, Surat, Gujarat, 395008.
                            </p>

                            <div className="footer-call-multi">
                                <a href="tel:+918758154926" className="footer-call-line" style={{ color: "#0f766e" }}>
                                    <span>Export Inquiry:</span>
                                    <IoCall style={{ color: "#0f766e" }} />
                                    <span>+91 8758154926</span>
                                </a>
                            </div>

                            <br />

                            <div className="footer-email-multi">
                                <div className="footer-contact-email" style={{ marginBottom: '10px' }}>
                                    <span>Domestic Inquiry:</span> <br />
                                    <a
                                        href="mailto:sales.india@krishnachemical-polymer.com"
                                        className="footer-mail"
                                        style={{ color: '#fff' }}
                                    >
                                        sales.india@krishnachemical-polymer.com
                                    </a>
                                </div>
                                <div className="footer-contact-email" style={{ marginBottom: '10px' }}>
                                    <span>Export Inquiry:</span><br />
                                    <a
                                        href="mailto:exports@krishnachemical-polymer.com"
                                        className="footer-mail"
                                        style={{ color: '#fff' }}
                                    >
                                        exports@krishnachemical-polymer.com
                                    </a>
                                </div>
                                <div className="footer-contact-email">
                                    <span>General Inquiry:</span><br />
                                    <a
                                        href="mailto:krishnachemicalandpolymer@gmail.com"
                                        className="footer-mail"
                                        style={{ color: '#fff' }}
                                    >
                                        krishnachemicalandpolymer@gmail.com
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* NEWSLETTER */}
                        <div className="footer-col">
                            <h4>Newsletter</h4>
                            <p>Get updates about products & industry insights.</p>

                            <div className="footer-newsletter">
                                <input
                                    type="email"
                                    placeholder="Your email address"
                                />
                                <button className="subscribe-btn btn-animate" style={{ color: "#fff", background: '#12645d' }}>
                                    Subscribe
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                {/* BOTTOM */}
                <div className="footer-bottom">
                    © 2026 Krishna Chemical & Polymer. All rights reserved.
                </div>

            </footer>
        </>
    );
};

export default Footer;
